import { defaultGetResponse } from "interfaces/ActionReducer/GetMethod/GetResponse";
import {
    BatchSelectionState,
    BatchSelectionTypes,
    SET_CURRENT_BATCH,
    STORE_BATCH_LINKS,
    STORE_BATCH_SHAPES,
    TOGGLE_BATCH_SELECTION,
    SHOW_BATCH_LIST_VIEW,
    SET_SELECTED_BATCH_IDS,
    SET_SELECTED_BATCH_REGULATIONS,
    BATCH_REGULATIONS_RECEIVED,
    GET_BATCH_REGULATIONS,
    TOGGLE_BATCH_ACTION_PERFORMED,
    GET_DELETE_BATCH_REGULATIONS,
    HIGHLIGHTED_BATCH_LINKS,
    SELECTED_BATCH_COLUMNS
} from "../../actions/regulation/BatchSelection/types";
import { RESET_STATE } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";

const initialState: BatchSelectionState = {
    batchLinks: {},
    batchShapes: {},
    currentBatch: null,
    isBatchSelectionEnabled: false,
    shouldShowBatchListView: false,
    selectedBatchData: [],
    selectedRowIds: [],
    highlightedBatchLinks: {},
    batchRegulations: defaultGetResponse.results,
    isFetchingBatchRegulations: false,
    actionPerformed: false,
    selectedColumns: [],
    selectedIds: [],
    selectedProposedIds: [],
    selectedRegulationIds: [],
    selectedRowActions: []
};

const batchSelection = (state = initialState, action: BatchSelectionTypes): BatchSelectionState => {
    switch (action.type) {
        case TOGGLE_BATCH_SELECTION: {
            return {
                ...state,
                isBatchSelectionEnabled: action.payload.isEnabled
            };
        }
        case SET_CURRENT_BATCH: {
            return {
                ...state,
                currentBatch: action.payload.currentBatch
            };
        }
        case STORE_BATCH_LINKS: {
            return {
                ...state,
                batchLinks: action.payload.batchLinks
            };
        }
        case SELECTED_BATCH_COLUMNS: {
            return {
                ...state,
                selectedColumns: action.payload.selectedColumns
            };
        }
        case HIGHLIGHTED_BATCH_LINKS: {
            return {
                ...state,
                highlightedBatchLinks: action.payload.highlightedBatchLinks
            };
        }
        case STORE_BATCH_SHAPES: {
            return {
                ...state,
                batchShapes: action.payload.batchShapes
            };
        }
        case SHOW_BATCH_LIST_VIEW: {
            return {
                ...state,
                shouldShowBatchListView: action.payload.shouldShowBatchListView
            };
        }
        case SET_SELECTED_BATCH_IDS: {
            return {
                ...state,
                selectedBatchData: action.payload.selectedBatchData
            };
        }
        case SET_SELECTED_BATCH_REGULATIONS: {
            return {
                ...state,
                selectedRowIds: action.payload.selectedRows,
                selectedIds: action.payload.selectedIds,
                selectedProposedIds: action.payload.selectedProposedIds,
                selectedRegulationIds: action.payload.selectedRegulationIds,
                selectedRowActions: action.payload.selectedRowsActions
            };
        }
        case BATCH_REGULATIONS_RECEIVED: {
            return {
                ...state,
                isFetchingBatchRegulations: false,
                batchRegulations: action.payload.data
            };
        }
        case GET_BATCH_REGULATIONS: {
            return {
                ...state,
                isFetchingBatchRegulations: true
            };
        }
        case GET_DELETE_BATCH_REGULATIONS: {
            return {
                ...state,
                isFetchingBatchRegulations: true
            };
        }
        case TOGGLE_BATCH_ACTION_PERFORMED: {
            return {
                ...state,
                actionPerformed: !state.actionPerformed
            };
        }
        case RESET_STATE: {
            return {
                ...initialState
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
};

export default batchSelection;
